export enum DeliverySettingsEndpoint {
  ROOT = '/delivery-settings',
}

export const staticDeliverySettingsEndpoints = {
  GET_DELIVERY_SETTINGS: DeliverySettingsEndpoint.ROOT,
  UPDATE_DELIVERY_SETTINGS: DeliverySettingsEndpoint.ROOT,
};

export const getDeliverySettingsEndpoints = ({ channelId }: { channelId: string | number }) => ({
  GET_DELIVERY_SETTINGS: `${DeliverySettingsEndpoint.ROOT}/${channelId}`,
  UPDATE_DELIVERY_SETTINGS: `${DeliverySettingsEndpoint.ROOT}/${channelId}`,
});

export interface IDeliverySettings {
  id: string;
  channelId: number;
  freeDelivery: IFreeDeliverySettings;
  upsDelivery: IUPSDeliverySettings;
  createdAt: string;
  updatedAt: string;
}

export interface IFreeDeliverySettings extends IExcludedStatesInCountries {
  isEnabled: boolean;
  minimalOrderAmount: number;
  popupTitle: string;
  popupDescription: string;
}

export interface IUPSDeliverySettings extends IExcludedStatesInCountries {
  isEnabled: boolean;
  price: number;
}

interface IExcludedStatesInCountries {
  excludedStatesUS: string[];
  excludedStatesCA: string[];
}

// ============== DTO ==============

export interface IGetDeliverySettingsDTO {
  channelId: number;
}

export interface IUpdateDeliverySettingsDTO extends Pick<IDeliverySettings, 'freeDelivery' | 'upsDelivery'> {
  channelId: number;
}

// ============== Response ==============

export interface IGetDeliverySettingsResponse extends IDeliverySettings {}

export interface IUpdateDeliverySettingsResponse extends IDeliverySettings {}
